import { isEmpty } from 'lodash';
import React from 'react';

import appleBlackLogoSrc from '../../../../assets/images/apple_black_logo.svg';

export default function MarketingLeadCaptureWithApple({
  eventName,
  returningUri,
  verificationUri,
  formLocation,
}: {
  eventName: string;
  formLocation: string;
  leadType: string;
  returningUri?: string;
  verificationUri: string;
}) {
  const appleId = window['AppleID'];
  const appleIdScriptLoaded = !isEmpty(appleId);

  if (!appleIdScriptLoaded) return null;

  return (
    <button
      id="apple-btn-container"
      className="tw-flex tw-items-center tw-h-40 tw-px-12 tw-border tw-border-solid tw-w-[250px] tw-rounded-4 tw-relative tw-overflow-hidden btn-google-signin"
      data-event-name={eventName}
      data-verification-uri={verificationUri}
      data-return-uri={returningUri}
      data-form-location={formLocation}
      data-page={window.location.pathname}
      onClick={() => appleId.auth.signIn()}
    >
      {/* empty div below is used for google sign in styling */}
      <div className="tw-absolute tw-inset-0"></div>
      <img src={appleBlackLogoSrc} className="tw-w-[18px] tw-relative" />
      <div className="tw-grow font-google-signin tw-relative">Continue with Apple</div>
    </button>
  );
}
